// assets/force-cart-page.js
(() => {
  const goCart = () => { window.location.href = '/cart'; };

  // 1) Clique sur l’icône panier / liens panier => /cart
  const bindCartLinks = () => {
    const selectors = [
      'a[href="/cart"]',
      'a[href^="/cart?"]',
      'a[href*="/cart"]',
      '[data-cart-link]',
      '[aria-label*="Panier"]',
      '[aria-label*="Cart"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      el.addEventListener('click', (e) => {
        // Si le thème essaye d’ouvrir un drawer, on bloque et on force /cart
        e.preventDefault();
        e.stopPropagation();
        goCart();
      }, { capture: true });
    });
  };

  // 2) Intercepte les appels AJAX Shopify d’ajout panier (/cart/add.js) et redirige /cart
  const interceptCartAdd = () => {
    // fetch()
    const _fetch = window.fetch;
    window.fetch = async function(input, init) {
      const url = typeof input === 'string' ? input : (input?.url || '');
      const res = await _fetch.apply(this, arguments);

      // Si un add-to-cart a eu lieu, on redirige
      if (url.includes('/cart/add')) {
        // petit timeout pour laisser le thème finir ses callbacks
        setTimeout(goCart, 50);
      }
      return res;
    };

    // XHR
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.__isCartAdd = (typeof url === 'string' && url.includes('/cart/add'));
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function() {
      this.addEventListener('load', () => {
        if (this.__isCartAdd) setTimeout(goCart, 50);
      });
      return _send.apply(this, arguments);
    };
  };

  // 3) Intercepte les formulaires "Add to cart" classiques (non-AJAX)
  const bindAddToCartForms = () => {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = (form.getAttribute('action') || '').toLowerCase();
      if (action.includes('/cart/add')) {
        // On laisse le submit normal se faire (Shopify gère),
        // mais si le thème détourne en AJAX, nos intercepts au-dessus couvrent.
        // Ici on ne bloque pas.
      }
    }, true);
  };

  const init = () => {
    bindCartLinks();
    interceptCartAdd();
    bindAddToCartForms();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Ré-applique si le thème remplace le header dynamiquement
  const mo = new MutationObserver(() => bindCartLinks());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();